import React from 'react';
import { connect } from 'react-redux';
import { updateServiceInvokerLogging, updateReportingEndpoint } from '../../actions/reduxActions/currentTenant';
import Toggle from '../Toggle';
import translations from '../../translations';
import { pathOr } from 'ramda';

export const Reporting = ({
    updateServiceInvokerLogging,
    updateReportingEndpoint,
    disableServiceInvokerLogging,
    endpoint,
}) => (
    <React.Fragment>
        <div className="form-group">
            <label>Reporting endpoint URL</label>
            <input
                className="form-control reporting-endpoint"
                maxLength="500"
                value={endpoint}
                onChange={({ target }) => updateReportingEndpoint(target.value)}
            />
        </div>
        <div className="form-group">
            <Toggle
                className="reporting-enable-logging"
                isOn={!disableServiceInvokerLogging}
                onChange={({ isOn }) => updateServiceInvokerLogging(isOn)}
            />
            <label>Enable Service Logging</label>
        </div>
    </React.Fragment>
);

export const mapStateToProps = ({ currentTenant }) => ({
    disableServiceInvokerLogging: pathOr(null, ['tenantSettings', 'disableServiceInvokerLogging'], currentTenant),
    endpoint: pathOr('', ['stateSettings', 'endpoint'], currentTenant),
});

const mapDispatchToProps = {
    updateServiceInvokerLogging,
    updateReportingEndpoint,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Reporting);
